/**
 * Removes trailing slash(es) from endpoint values in a `;`-delimited connection
 * string. Telemetry SDKs (e.g. Application Insights) append a path such as
 * `/v2/track` to the IngestionEndpoint; a trailing slash there produces a broken
 * `//v2/track`. Stripping it keeps the URL valid even if the configured endpoint
 * is hardcoded with a trailing slash. The protocol `://` is left untouched.
 */
export default function sanitizeConnectionString(connectionString: string): string {
  return connectionString
    .split(';')
    .map((segment) => {
      let end = segment.length;
      while (end > 0 && segment[end - 1] === '/') {
        end--;
      }
      return segment.slice(0, end);
    })
    .join(';');
}
